import React from 'react';
import { Divider, Flex, Box } from '@opendoor/bricks/core';
import { ExternalLink } from 'platform/react-router';

/** TODO: Add documentation */
export const OnChangeCtaWithDivider: React.FC<{
  onChange?: () => void;
}> = ({ onChange }) => (
  <>
    <Box pt={2}>
      <Divider />
    </Box>
    {onChange && (
      <>
        <Divider />
        <Flex justifyContent="center" alignItems="center" mt={4}>
          <ExternalLink
            // TODO @sellDirect - Semantic links without href props are a11y violations. See https://opendoor.atlassian.net/wiki/spaces/SELL/pages/1943339236/Accessibility+best+practices+for+frontend+development#Common-anti-patterns-to-look-out-for-in-progress

            onClick={onChange}
            fontSize="s000"
            fontWeight="bold"
            analyticsName="cake-legacy-change-with-divider"
            aria-label={null}
          >
            CHANGE
          </ExternalLink>
        </Flex>
      </>
    )}
  </>
);
